import "../scss/style.scss";
import jQuery from "jquery";

import { gsap } from "gsap/dist/gsap";
import { Power2 } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/css";

gsap.registerPlugin(ScrollTrigger);
Swiper.use([Pagination, Autoplay]);

!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value = window.outerWidth > 375 ? "width=device-width,initial-scale=1" : "width=375";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

// header
jQuery(".js-header-toggle-button").on("click", () => {
  jQuery(".js-header-toggle").toggleClass("is--open");
});

jQuery(".js-nav-item").on("click", () => {
  jQuery(".js-header-toggle").removeClass("is--open");
});

// faq
const faqButtons = document.querySelectorAll(".js-faq-toggle-button");
faqButtons.forEach((button) => {
  button.addEventListener("click", () => {
    let faqAnswer = button.nextElementSibling;
    jQuery(button).toggleClass("is--open");
    jQuery(faqAnswer).slideToggle();
  });
});

// smooth
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    // href属性のIDを取得
    const href = anchor.getAttribute("href");
    const target = document.getElementById(href.replace("#", ""));

    console.log(target.getBoundingClientRect().top);

    let targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 90;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  });
});

// swiper
const voiceSwiper = new Swiper(".js-voice-swiper", {
  slidesPerView: 1.005,
  spaceBetween: 25,
  speed: 700,
  centeredSlides: true,
  initialSlide: 1,

  pagination: {
    el: ".js-voice-pagination",
    clickable: true,
  },

  breakpoints: {
    992: {
      slidesPerView: 3,
    },
  },
});

const changeSwiper = new Swiper(".js-change-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 700,

  pagination: {
    el: ".js-change-pagination",
    clickable: true,
  },
});

const trainerSwiper = new Swiper(".js-trainer-swiper", {
  slidesPerView: 1.02,
  spaceBetween: 30,
  speed: 700,
  centeredSlides: true,
  loopAdditionalSlides: 2,
  initialSlide: 1,

  pagination: {
    el: ".js-trainer-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 1.5,
    },
    992: {
      slidesPerView: 3,
      loop: false,
    },
  },
});

// fade up
const fadeUpEls = document.querySelectorAll(".js-fade-up");
const fadeScrollTriggerObj = (el) => {
  return {
    trigger: el,
    start: "top-=120 center",
    end: "bottom center",
  };
};

fadeUpEls.forEach((el) => {
  gsap.to(el, {
    y: 0,
    opacity: 1,
    scale: 1,
    duration: 1,
    ease: Power2.out,
    scrollTrigger: fadeScrollTriggerObj(el),
  });
});
